// extracted by mini-css-extract-plugin
module.exports = {"button":"UploadButton_button__2s_T2","button__name":"UploadButton_button__name__1wbuj","button__content":"UploadButton_button__content__1Q6Fs"};